export const GetPersonalAddressesQuery = `query {
  personData {
    addresses {
      addresseeFirstName
      addresseeLastName
      addressSupplement
      buildingNumber
      city
      contactChannels {
        type
      }
      country
      id
      postalCode
      province
      street
    }
  }
}
`;

export const GetBusinessAddressesQuery = `query($accountId: ID!) {
  accountData(accountId: $accountId) {
    addresses {
      addresseeCompany
      addresseeFirstName
      addresseeLastName
      addressSupplement
      buildingNumber
      city
      contactChannels {
        type
      }
      country
      id
      postalCode
      province
      street
    }
  }
}
`;
